(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconZeroPendingRedactions)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconZeroPendingRedactions/zero-pending-redactions.inline.svg?raw
/* harmony default export */ const zero_pending_redactions_inlineraw = ("<svg width=\"16\" height=\"16\" viewBox=\"0 0 72 49\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.82218 47.2074H39.3484V37.971H1.82218V47.2074ZM41.1262 49V36.1784H0.0443989V49H41.1262Z\" />\n<path d=\"M71.9531 47.7025C70.1475 47.7025 69.3434 46.1132 68.8114 45.0619C68.6371 44.7178 68.3551 44.1607 68.1709 43.9882C67.9851 44.1607 67.7031 44.7178 67.5296 45.0619C66.9976 46.1132 66.1927 47.7025 64.3887 47.7025C62.584 47.7025 61.7798 46.1132 61.2478 45.0619C61.0744 44.7178 60.7932 44.1623 60.609 43.9882C60.4232 44.1623 60.142 44.7178 59.9685 45.0619C59.4373 46.1132 58.6324 47.7025 56.8284 47.7025C55.0237 47.7025 54.2195 46.1132 53.6876 45.0619C53.5141 44.7178 53.2337 44.1632 53.0487 43.9891C52.8637 44.1632 52.5833 44.7178 52.4098 45.0619C51.8787 46.1132 51.0745 47.7025 49.2706 47.7025C47.4666 47.7025 46.6625 46.1132 46.1314 45.0619C45.9423 44.6863 45.6249 44.0595 45.4432 43.9518C45.4547 43.9576 45.4794 43.9659 45.4925 43.9659V41.1354C47.2965 41.1354 48.1006 42.7247 48.6317 43.7768C48.8052 44.1192 49.0856 44.6747 49.2706 44.8488C49.4556 44.6747 49.736 44.1192 49.9095 43.7768C50.4406 42.7247 51.2447 41.1354 53.0487 41.1354C54.8535 41.1354 55.6568 42.7247 56.1887 43.776C56.3631 44.1192 56.6442 44.6755 56.8284 44.8497C57.0134 44.6755 57.2946 44.1192 57.4689 43.776C58.0001 42.7247 58.8042 41.1354 60.609 41.1354C62.4129 41.1354 63.2171 42.7247 63.749 43.776C63.9233 44.1201 64.2045 44.6755 64.3887 44.8497C64.5745 44.6764 64.8557 44.1192 65.0292 43.776C65.5612 42.7239 66.3653 41.1354 68.1709 41.1354C69.9757 41.1354 70.779 42.7239 71.3118 43.776C71.5009 44.1507 71.8191 44.7783 72 44.8861C71.9885 44.8795 71.9646 44.872 71.9523 44.872L71.9531 47.7025Z\" />\n<path d=\"M26.5091 9.7366C24.7044 9.7366 23.9002 8.14811 23.3683 7.09685C23.194 6.75278 22.9119 6.19565 22.7269 6.0232C22.5419 6.19565 22.2599 6.75278 22.0856 7.09685C21.5544 8.14811 20.7495 9.7366 18.9447 9.7366C17.1408 9.7366 16.3367 8.14811 15.8055 7.09685C15.6312 6.75278 15.35 6.1973 15.165 6.0232C14.98 6.1973 14.6996 6.75278 14.5253 7.09685C13.9933 8.14811 13.1892 9.7366 11.3844 9.7366C9.58049 9.7366 8.77636 8.14811 8.2452 7.09602C8.07172 6.75278 7.78969 6.19813 7.60552 6.02403C7.4197 6.19813 7.14014 6.75278 6.96665 7.09602C6.43468 8.14811 5.63137 9.7366 3.8266 9.7366C2.02266 9.7366 1.21935 8.14811 0.687374 7.09602C0.498264 6.72128 0.180888 6.0945 0 5.98589C0.0115111 5.99252 0.0361776 5.99999 0.049333 6.00081L0.0485109 3.17037C1.85246 3.17037 2.65741 4.7597 3.18856 5.81096C3.36205 6.15419 3.64243 6.70884 3.8266 6.88295C4.01242 6.70884 4.29198 6.15419 4.46547 5.81096C4.99744 4.7597 5.80157 3.17037 7.60552 3.17037C9.40946 3.17037 10.2136 4.7597 10.7447 5.81096C10.9191 6.15502 11.2003 6.7105 11.3844 6.88377C11.5703 6.7105 11.8515 6.15502 12.0249 5.81096C12.5569 4.75887 13.361 3.17037 15.1658 3.17037C16.9698 3.17037 17.7739 4.7597 18.305 5.81096C18.4794 6.15502 18.7606 6.7105 18.9456 6.88377C19.1314 6.7105 19.4117 6.15502 19.5861 5.81013C20.118 4.75887 20.9222 3.17037 22.7269 3.17037C24.5317 3.17037 25.3367 4.75887 25.8678 5.81013C26.0577 6.1857 26.3759 6.8133 26.5568 6.92108C26.5461 6.91445 26.5215 6.90699 26.5083 6.90699L26.5091 9.7366Z\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.1753 20.0888H1.82218V29.4114H70.1753V20.0888ZM71.9531 18.2962V31.204H0.0443989V18.2962H71.9531Z\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.1762 1.79259H32.5846V11.1152H70.1762V1.79259ZM71.954 0V12.9078H30.8069V0H71.954Z\" />\n</svg>\n");
;// ./src/components/Icon/IconZeroPendingRedactions/IconZeroPendingRedactions.tsx



const IconZeroPendingRedactions = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: zero_pending_redactions_inlineraw }, props)));
/* harmony default export */ const IconZeroPendingRedactions_IconZeroPendingRedactions = (IconZeroPendingRedactions);

;// ./src/components/Icon/IconZeroPendingRedactions/index.ts

/* harmony default export */ const Icon_IconZeroPendingRedactions = (IconZeroPendingRedactions_IconZeroPendingRedactions);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map